import React, { useEffect, useState, memo, createElement } from 'react';
import { ChevronDown, Check, ShieldCheck, Lock, CreditCard, HelpCircle, AlertTriangle, BookOpen, Heart, Users, Gift } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { CTAButton } from './components/CTAButton';
import { TestimonialCard } from './components/TestimonialCard';
export function App() {
  // Meta Pixel Integration
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '885866990629991');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=885866990629991&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
  }, []);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    q: '¿Es material digital?',
    a: 'Sí, se entrega en PDF y llega al instante.'
  }, {
    q: '¿Funciona para cualquier edad?',
    a: 'Sí, las actividades se adaptan a cada familia.'
  }, {
    q: '¿Se puede imprimir?',
    a: 'Sí, perfectamente.'
  }, {
    q: '¿Sirve aunque tengamos poco tiempo?',
    a: 'Justamente está pensado para eso.'
  }];
  const bonuses = [{
    title: 'Bono #1 – Adios al aburrimiento 52 planes mágicos y economicos',
    desc: 'Ideas listas para todo el año, sin pensar.',
    img: 'https://cdn.magicpatterns.com/uploads/2R4xT7m85n4thrbxN8Vkxn/BONO_2.png'
  }, {
    title: 'Bono #2 – Juegos para-Descubrir lo que Tu Hija Realmente Piensa y Siente',
    desc: 'Dinámicas para conocerse mejor y abrir conversaciones reales.',
    img: 'https://cdn.magicpatterns.com/uploads/vd6PYYow3c9ZtvWdGcWJS1/BONO_1.png'
  }, {
    title: 'Bono #3 – 30 cosas que quiero que mi hija nunca olvide aunque yo no este',
    desc: 'Frases y mensajes para guardar para siempre.',
    img: 'https://cdn.magicpatterns.com/uploads/wJDf6dAfCTYYDQfEzH9uWq/BONO_3.png'
  }, {
    title: 'Bono #4 – Abuelita, cuéntame tu historia',
    desc: 'Un hermoso libro para que tu abuela comparta sus recuerdos, anécdotas y enseñanzas de vida.',
    img: 'https://cdn.magicpatterns.com/uploads/akhJP4pXk6V5aVW2aFHBEd/BONO_4.png'
  }, {
    title: 'Bono #5 – Abuelito, cuéntame tu historia',
    desc: 'Un espacio para que el abuelo cuente sus vivencias, sabiduría y recuerdos que quedarán para siempre.',
    img: 'https://cdn.magicpatterns.com/uploads/3FpY5CTan4q6KXEDKXNSMa/BONO_5.png'
  }, {
    title: 'Bono #6 – Mamá, cuéntame tu historia',
    desc: 'Un recuerdo invaluable donde mamá puede dejar plasmadas sus experiencias, consejos y momentos más especiales.',
    img: 'https://cdn.magicpatterns.com/uploads/92HR4yVGGmq5KmZQpwtpGN/BONO_6.png'
  }, {
    title: 'Bono #7 – Papá, cuéntame tu historia',
    desc: 'Un libro para que papá comparta sus recuerdos, enseñanzas y los momentos que marcaron su vida.',
    img: 'https://cdn.magicpatterns.com/uploads/bkZRYgYEwHZbMbGTMPbGrC/BONO_7.png'
  }];
  return <div className="font-sans text-gray-900 bg-white pt-12" data-id="element-0">
      <CountdownTimer data-id="element-1" />
      <PurchaseNotification data-id="element-2" />

      {/* HERO SECTION */}
      <header className="bg-white pb-12 pt-8 px-4 text-center border-b border-gray-200" data-id="element-3">
        <div className="max-w-4xl mx-auto" data-id="element-4">
          <h1 className="text-4xl md:text-6xl font-black mb-6 leading-tight tracking-tight" data-id="element-5">
            <span className="text-red-600" data-id="element-6">❤️ Pack 100 Citas</span>
            <br data-id="element-7" />
            <span className="text-3xl md:text-5xl font-bold text-gray-800 mt-2 block" data-id="element-8">
              Mamá • Papá • Pareja • Familia
            </span>
          </h1>

          <div className="my-8 flex justify-center" data-id="element-9">
            <a href="https://checkout.descargatop.com/cart/40898068152369:1" className="block" data-id="element-10">
              <img src="https://cdn.magicpatterns.com/uploads/q68Va7f1235i4y2MMkjDDD/MOCAP_100_CITAS.png" alt="Pack 100 Citas Completo" className="w-full max-w-2xl drop-shadow-2xl hover:scale-[1.02] transition-transform duration-300 cursor-pointer" data-id="element-11" />
            </a>
          </div>

          <div className="bg-yellow-100 border-l-8 border-yellow-400 p-6 mb-8 text-left max-w-3xl mx-auto rounded-r-lg shadow-sm" data-id="element-12">
            <p className="text-xl md:text-2xl font-bold text-gray-800 mb-2" data-id="element-13">
              Momentos reales. Conexión verdadera. Recuerdos que quedan para
              siempre.
            </p>
            <p className="text-lg text-gray-700" data-id="element-14">
              Tiempo de calidad listo para usar, sin pantallas y sin tener que
              pensar qué hacer.
            </p>
          </div>

          <CTAButton text="SÍ, QUIERO ACCEDER AHORA" subtext="Descarga Digital Inmediata" data-id="element-15" />

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-gray-600 font-medium" data-id="element-16">
            <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-17" />
            Garantía de satisfacción de 7 días
          </div>
        </div>
      </header>

      {/* HOOK / PROBLEM SECTION */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-18">
        <div className="max-w-3xl mx-auto" data-id="element-19">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-20">
            Si sos mamá, papá o estás en pareja, dejame hacerte una pregunta
            honesta
          </h2>

          <div className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100" data-id="element-21">
            <p className="text-xl md:text-2xl font-bold text-center mb-6" data-id="element-22">
              ¿Sentís que el tiempo pasa… <br data-id="element-23" />
              <span className="bg-yellow-200 px-2" data-id="element-24">
                pero los momentos importantes se te escapan?
              </span>
            </p>

            <div className="space-y-4 text-lg text-gray-700 leading-relaxed" data-id="element-25">
              <p data-id="element-26">No porque no ames a tu familia.</p>
              <p data-id="element-27">No porque no quieras estar.</p>
              <p className="font-semibold" data-id="element-28">
                Sino porque la rutina, el cansancio y las pantallas lo ocupan
                todo.
              </p>
              <p data-id="element-29">
                Y cuando te das cuenta…{' '}
                <span className="font-bold text-red-600" data-id="element-30">el día terminó.</span>
              </p>
            </div>
          </div>

          <div className="mt-12" data-id="element-31">
            <h3 className="text-2xl font-black text-center mb-8 uppercase tracking-wide text-gray-800" data-id="element-32">
              El problema que nadie dice en voz alta
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-33">
              {['Compartís tiempo, pero no conexión real', 'Cada uno está con su celular', 'Querés hacer algo especial, pero no sabés qué', 'Los días pasan rápido', 'Los hijos crecen', 'La pareja entra en piloto automático'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm border-l-4 border-red-500" data-id="element-34">
                  <AlertTriangle className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-35" />
                  <span className="font-medium" data-id="element-36">{item}</span>
                </div>)}
            </div>

            <div className="mt-10 text-center bg-gray-800 text-white p-6 rounded-xl shadow-lg" data-id="element-37">
              <p className="text-lg mb-2" data-id="element-38">
                Y aparece ese pensamiento incómodo:
              </p>
              <p className="text-2xl font-bold italic" data-id="element-39">
                "Podría estar haciendo más… si tuviera una forma simple de
                hacerlo."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-40">
        <div className="max-w-4xl mx-auto text-center" data-id="element-41">
          <div className="inline-block bg-green-100 text-green-800 px-4 py-1 rounded-full font-bold mb-4 border border-green-200" data-id="element-42">
            ✅ La solución
          </div>
          <h2 className="text-4xl md:text-5xl font-black mb-6 text-gray-900" data-id="element-43">
            ❤️ Pack 100 Citas
          </h2>
          <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto" data-id="element-44">
            Un sistema simple de momentos guiados, diseñado para ayudarte a
            conectar de verdad con las personas que más amás.
          </p>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-45">
            <div className="bg-blue-50 p-8 rounded-2xl border-2 border-blue-100 hover:border-blue-300 transition-colors" data-id="element-46">
              <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md text-3xl" data-id="element-47">
                📖
              </div>
              <h3 className="font-bold text-xl mb-2" data-id="element-48">Abrís el libro</h3>
              <p className="text-gray-600" data-id="element-49">
                Sin complicaciones ni preparativos eternos.
              </p>
            </div>
            <div className="bg-purple-50 p-8 rounded-2xl border-2 border-purple-100 hover:border-purple-300 transition-colors" data-id="element-50">
              <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md text-3xl" data-id="element-51">
                👆
              </div>
              <h3 className="font-bold text-xl mb-2" data-id="element-52">Elegís una cita</h3>
              <p className="text-gray-600" data-id="element-53">
                Actividades diseñadas para cada vínculo.
              </p>
            </div>
            <div className="bg-red-50 p-8 rounded-2xl border-2 border-red-100 hover:border-red-300 transition-colors" data-id="element-54">
              <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md text-3xl" data-id="element-55">
                ❤️
              </div>
              <h3 className="font-bold text-xl mb-2" data-id="element-56">Vivís el momento</h3>
              <p className="text-gray-600" data-id="element-57">
                Sin pantallas. Sin planificar. Sin estrés.
              </p>
            </div>
          </div>

          <CTAButton text="QUIERO EL PACK 100 CITAS AHORA" data-id="element-58" />
        </div>
      </section>

      {/* WHAT'S INCLUDED */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-59">
        <div className="max-w-4xl mx-auto" data-id="element-60">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-61">
            📚 ¿Qué incluye exactamente el Pack 100 Citas?
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-62">
            {[{
            title: '100 Citas Mamá e Hija',
            desc: 'Momentos uno a uno para hablar, reír y fortalecer el vínculo.',
            icon: Heart
          }, {
            title: '100 Citas Mamá e Hijo',
            desc: 'Actividades para conectar desde el juego, la escucha y el amor.',
            icon: Users
          }, {
            title: '100 Citas Papá e Hija',
            desc: 'Espacios únicos para reforzar seguridad, confianza y cercanía.',
            icon: ShieldCheck
          }, {
            title: '100 Citas Papá e Hijo',
            desc: 'Propuestas para compartir tiempo real y crear recuerdos juntos.',
            icon: BookOpen
          }].map((item, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border-l-4 border-blue-500 flex gap-4" data-id="element-63">
                <div className="bg-blue-100 p-3 rounded-full h-fit" data-id="element-64">
                  <item.icon className="w-6 h-6 text-blue-600" data-id="element-65" />
                </div>
                <div data-id="element-66">
                  <h3 className="font-bold text-lg mb-1" data-id="element-67">✅ {item.title}</h3>
                  <p className="text-gray-600 text-sm" data-id="element-68">{item.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="bg-yellow-50 p-8 rounded-2xl border-2 border-yellow-200 mb-12" data-id="element-69">
            <h3 className="text-xl font-bold mb-6 text-center" data-id="element-70">
              🆕 Incluidos también en el Pack
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-71">
              {[{
              title: '100 Citas en Pareja',
              desc: 'Para salir de la rutina, volver a hablar, reír y reconectar.'
            }, {
              title: '100 Citas en Familia',
              desc: 'Actividades para hacer todos juntos y crear recuerdos compartidos.'
            }].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-72">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-73" />
                  <div data-id="element-74">
                    <h4 className="font-bold text-lg" data-id="element-75">{item.title}</h4>
                    <p className="text-gray-700" data-id="element-76">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="text-center bg-gray-900 text-white p-6 rounded-xl shadow-xl transform rotate-1 hover:rotate-0 transition-transform" data-id="element-77">
            <p className="text-2xl font-bold" data-id="element-78">
              👉 Un solo Pack. 👉 Todos los vínculos importantes cubiertos.
            </p>
          </div>
        </div>
      </section>

      {/* BEFORE VS AFTER */}
      <section className="py-16 px-4 bg-white" data-id="element-79">
        <div className="max-w-5xl mx-auto" data-id="element-80">
          <h2 className="text-3xl font-black text-center mb-12" data-id="element-81">
            🔄 Antes vs Después
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-82">
            <div className="bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-83">
              <h3 className="text-2xl font-bold text-red-600 mb-6 flex items-center gap-2" data-id="element-84">
                <span className="text-3xl" data-id="element-85">❌</span> Antes del Pack
              </h3>
              <ul className="space-y-4" data-id="element-86">
                {['Rutina automática', 'Mucho celular', 'Poco diálogo', 'Cansancio emocional', 'Sensación de culpa', '“Después lo hacemos…”'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-87">
                    <div className="w-2 h-2 bg-red-400 rounded-full" data-id="element-88" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="bg-green-50 p-8 rounded-2xl border-2 border-green-200 shadow-lg relative overflow-hidden" data-id="element-89">
              <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-90">
                TU NUEVA VIDA
              </div>
              <h3 className="text-2xl font-bold text-green-700 mb-6 flex items-center gap-2" data-id="element-91">
                <span className="text-3xl" data-id="element-92">✅</span> Después del Pack
              </h3>
              <ul className="space-y-4" data-id="element-93">
                {['Momentos reales', 'Risas y charlas', 'Tiempo de calidad', 'Más conexión', 'Tranquilidad emocional', 'Recuerdos que quedan'].map((item, i) => <li key={i} className="flex items-center gap-3 font-medium text-gray-800" data-id="element-94">
                    <Check className="w-5 h-5 text-green-600" data-id="element-95" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-96">
        <div className="max-w-5xl mx-auto" data-id="element-97">
          <div className="text-center mb-16" data-id="element-98">
            <span className="bg-yellow-400 text-black font-black px-4 py-1 rounded uppercase tracking-wider text-sm" data-id="element-99">
              Oferta Especial
            </span>
            <h2 className="text-4xl md:text-5xl font-black mt-4 mb-4 text-white" data-id="element-100">
              🎁 REGALOS ESPECIALES
            </h2>
            <p className="text-xl text-gray-300" data-id="element-101">
              BONOS INCLUIDOS HOY (Sin costo adicional)
            </p>
          </div>

          <div className="space-y-12" data-id="element-102">
            {bonuses.map((bonus, index) => <div key={index} className="bg-gray-800 rounded-2xl p-6 md:p-8 border border-gray-700 flex flex-col md:flex-row gap-8 items-center" data-id="element-103">
                {bonus.img ? <a href="https://checkout.descargatop.com/cart/40898068152369:1" className="w-full md:w-1/3 flex-shrink-0" data-id="element-104">
                    <img src={bonus.img} alt={bonus.title} className="w-full rounded-lg shadow-2xl transform hover:scale-105 transition-transform duration-300 cursor-pointer" data-id="element-105" />
                  </a> : <div className="w-full md:w-1/3 flex-shrink-0 bg-gray-700 h-64 rounded-lg flex items-center justify-center text-gray-500" data-id="element-106">
                    <Gift className="w-16 h-16 opacity-50" data-id="element-107" />
                  </div>}
                <div className="flex-1 text-center md:text-left" data-id="element-108">
                  <div className="inline-block bg-green-600 text-white text-xs font-bold px-2 py-1 rounded mb-3" data-id="element-109">
                    GRATIS HOY
                  </div>
                  <h3 className="text-2xl font-bold text-yellow-400 mb-3" data-id="element-110">
                    {bonus.title}
                  </h3>
                  <p className="text-lg text-gray-300" data-id="element-111">{bonus.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-112">
            <p className="text-2xl font-bold text-white mb-8" data-id="element-113">
              👉 Legado familiar + memoria emocional.
            </p>
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section className="py-16 px-4 bg-white relative overflow-hidden" data-id="element-114">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px] opacity-50" data-id="element-115"></div>
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-116">
          <div className="bg-white rounded-3xl shadow-2xl border-4 border-yellow-400 overflow-hidden" data-id="element-117">
            <div className="bg-red-600 text-white text-center py-4 px-4 animate-pulse" data-id="element-118">
              <p className="font-bold text-lg uppercase tracking-wider" data-id="element-119">
                ⏰ Oferta por tiempo limitado
              </p>
            </div>

            <div className="p-8 md:p-12 text-center" data-id="element-120">
              <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-2" data-id="element-121">
                Accedé al Pack 100 Citas completo
              </h2>
              <p className="text-gray-500 mb-8 font-medium" data-id="element-122">
                todos los bonos incluidos
              </p>

              <div className="bg-gray-50 rounded-xl p-6 mb-8 text-left max-w-md mx-auto border border-gray-200" data-id="element-123">
                <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-124">
                  <Gift className="w-5 h-5 text-purple-600" data-id="element-125" />
                  📦 Lo que vas a recibir hoy:
                </h3>
                <ul className="space-y-3" data-id="element-126">
                  <li className="flex items-start gap-3" data-id="element-127">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-128" />
                    <span className="text-gray-700" data-id="element-129">
                      6 libros principales (mamá, papá, pareja y familia)
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-130">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-131" />
                    <span className="text-gray-700 font-bold" data-id="element-132">
                      7 bonos emocionales exclusivos
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-133">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-134" />
                    <span className="text-gray-700" data-id="element-135">
                      Actividades listas para usar
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-136">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-137" />
                    <span className="text-gray-700" data-id="element-138">
                      Formato PDF (celular, tablet, PC)
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-139">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-140" />
                    <span className="text-gray-700" data-id="element-141">Acceso inmediato</span>
                  </li>
                </ul>
              </div>

              <div className="mb-8" data-id="element-142">
                <p className="text-gray-500 line-through text-xl mb-1" data-id="element-143">
                  Precio regular: USD $25
                </p>
                <div className="flex items-center justify-center gap-2" data-id="element-144">
                  <span className="text-6xl font-black text-green-600 tracking-tighter" data-id="element-145">
                    USD $12,99
                  </span>
                </div>
                <p className="text-red-500 font-bold mt-2 animate-bounce" data-id="element-146">
                  🔥 HOY SOLO
                </p>
                <p className="text-xs text-gray-400 mt-1" data-id="element-147">
                  Pagás en la moneda de tu país
                </p>
              </div>

              <CTAButton text="QUIERO EL PACK 100 CITAS AHORA" className="w-full md:w-full" data-id="element-148" />

              <div className="mt-6 flex justify-center gap-4 opacity-60 grayscale hover:grayscale-0 transition-all" data-id="element-149">
                <CreditCard className="w-8 h-8" data-id="element-150" />
                <Lock className="w-8 h-8" data-id="element-151" />
                <ShieldCheck className="w-8 h-8" data-id="element-152" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE SECTION */}
      <section className="py-12 px-4 bg-gray-50 border-y border-gray-200" data-id="element-153">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-8" data-id="element-154">
          <div className="flex-shrink-0" data-id="element-155">
            <div className="w-32 h-32 bg-yellow-400 rounded-full flex items-center justify-center border-4 border-yellow-200 shadow-lg rotate-12" data-id="element-156">
              <ShieldCheck className="w-16 h-16 text-white" data-id="element-157" />
            </div>
          </div>
          <div className="text-center md:text-left" data-id="element-158">
            <h3 className="text-2xl font-black mb-2" data-id="element-159">🔒 Garantía sin riesgo</h3>
            <p className="text-lg text-gray-700 mb-4" data-id="element-160">
              Probalo durante 7 días. Si no es para vos, te devolvemos el 100%
              del dinero.
            </p>
            <div className="flex flex-wrap justify-center md:justify-start gap-4 font-bold text-gray-900" data-id="element-161">
              <span className="flex items-center gap-1" data-id="element-162">
                <Check className="w-4 h-4 text-green-500" data-id="element-163" /> Sin preguntas.
              </span>
              <span className="flex items-center gap-1" data-id="element-164">
                <Check className="w-4 h-4 text-green-500" data-id="element-165" /> Sin letra chica.
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-white" data-id="element-166">
        <div className="max-w-6xl mx-auto" data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-168">
            💬 Lo que dicen otras familias
          </h2>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-169">
            <TestimonialCard quote="Mi hija espera cada cita con ilusión. Nos acercó muchísimo." author="María" role="mamá de 2 hijos" data-id="element-170" />
            <TestimonialCard quote="Nos devolvió momentos que la rutina nos estaba robando." author="Lucas" role="papá" data-id="element-171" />
            <TestimonialCard quote="Como pareja volvimos a hablar y reírnos juntos." author="Carla" role="en pareja" data-id="element-172" />
            <div className="md:col-span-1" data-id="element-173">
              <TestimonialCard quote="No es un libro. Es tiempo de calidad real." author="Andrea" role="mamá" data-id="element-174" />
            </div>
            <div className="md:col-span-2" data-id="element-175">
              <TestimonialCard quote="Mis hijos ahora me buscan para hacer las citas. Cambió nuestra dinámica familiar completamente." author="Roberto" role="papá de 3" data-id="element-176" />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-177">
        <div className="max-w-3xl mx-auto" data-id="element-178">
          <h2 className="text-3xl font-black text-center mb-12 flex items-center justify-center gap-3" data-id="element-179">
            <HelpCircle className="w-8 h-8 text-blue-500" data-id="element-180" />
            Preguntas frecuentes
          </h2>
          <div className="space-y-4" data-id="element-181">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-182">
                <button onClick={() => toggleFaq(index)} className="w-full flex items-center justify-between p-5 text-left font-bold text-gray-900 hover:bg-gray-50 transition-colors" data-id="element-183">
                  {faq.q}
                  <ChevronDown className={`w-5 h-5 transition-transform ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-184" />
                </button>
                {openFaq === index && <div className="p-5 pt-0 text-gray-600 border-t border-gray-100 bg-gray-50" data-id="element-185">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-20 px-4 bg-white text-center" data-id="element-186">
        <div className="max-w-4xl mx-auto" data-id="element-187">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-188">
            ❤️ La conexión no se posterga
          </h2>
          <p className="text-2xl text-gray-600 mb-12" data-id="element-189">
            No necesitás más tiempo. <br data-id="element-190" />
            <span className="font-bold text-gray-900" data-id="element-191">
              Necesitás mejores momentos.
            </span>
          </p>
          <CTAButton text="Accedé ahora al Pack 100 Citas" data-id="element-192" />
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-193">
        <div className="max-w-4xl mx-auto" data-id="element-194">
          <p className="mb-4" data-id="element-195">© 2026 DescargaTop – Pack 100 Citas</p>
          <p className="mb-8" data-id="element-196">Todos los derechos reservados</p>
          <div className="flex justify-center gap-6" data-id="element-197">
            <a href="#" className="hover:text-white transition-colors" data-id="element-198">
              Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-199">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </footer>
    </div>;
}